import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../styles/views/components/CheckboxComponent.module.scss';

const CheckboxComponent = ({
  name,
  children,
  onChange,
  color,
  size,
  labelStyling,
  classes,
  stylesConfig,
  ...inputProps
}) => (
  <div style={{ ...stylesConfig.wrapper }} className={styles.wrapper}>
    <input
      type="checkbox"
      id={name}
      className={styles.inputCheckboxHidden}
      onChange={onChange}
      {...inputProps}
    />
    <label
      style={{ width: size, height: size, ...stylesConfig.square }}
      className={color === 'red' ? styles.squareRed : styles.squareBrown}
      htmlFor={name}
    >
      <i className={styles.checkmark} />
    </label>
    {children && (
      <label
        htmlFor={name}
        className={[styles.label, classes.label].join(' ')}
        style={labelStyling}
      >
        {children}
      </label>
    )}
  </div>
);

CheckboxComponent.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string,
  children: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  size: PropTypes.string,
  labelStyling: PropTypes.shape({}),
  classes: PropTypes.shape({
    label: PropTypes.string,
  }),
  stylesConfig: PropTypes.object,
};
CheckboxComponent.defaultProps = {
  children: null,
  color: '',
  size: '24px',
  labelStyling: {
    paddingLeft: '10px',
    lineHeight: '24px',
    fontSize: '16px',
  },
  classes: {},
  stylesConfig: {},
};

export default CheckboxComponent;
